<script lang="ts">
  // Portal Button — a thin ADAPTER over the shared shadcn-svelte Button
  // (@price-check/ui). It keeps the portal's ergonomic semantic API
  // (variant primary/secondary/danger/ghost · size sm/md · full) so existing call
  // sites are unchanged, but rendering + styling now come from the genuine shared
  // component (no per-app arbitrary values, no stale focus colour — unified brand).
  import type { Snippet } from "svelte";
  import { Button, type ButtonVariant, type ButtonSize } from "@price-check/ui";

  let {
    variant = "primary",
    type = "button",
    disabled = false,
    size = "md",
    full = false,
    title,
    onclick,
    children,
  }: {
    variant?: "primary" | "secondary" | "danger" | "ghost";
    type?: "button" | "submit";
    disabled?: boolean;
    size?: "sm" | "md";
    full?: boolean;
    title?: string;
    onclick?: (e: MouseEvent) => void;
    children: Snippet;
  } = $props();

  const VARIANT: Record<string, ButtonVariant> = {
    primary: "primary",
    secondary: "secondary",
    danger: "destructive",
    ghost: "ghost",
  };
  const SIZE: Record<string, ButtonSize> = { md: "default", sm: "sm" };

  const sharedVariant = $derived(VARIANT[variant]);
  const sharedSize = $derived(SIZE[size]);
</script>

<Button
  variant={sharedVariant}
  size={sharedSize}
  {type}
  {disabled}
  {title}
  {onclick}
  class={full ? "w-full" : undefined}
>
  {@render children()}
</Button>
